export const reportContentTop = [
    {
        id: "owners",
        title: "Владельцы",
        text: "Предоставим информацию обо всех владельцах транспортного средства, включая юридических лиц.\nЭто позволит определить, эксплуатировалось ли авто в сфере такси или каршеринга."
    },
    {
        id: "legal",
        title: "Юридическая чистота",
        text: "Покажем все юридические риски: нахождение в залоге, статус в розыске, ограничения регистрации и другие скрытые проблемы."
    }
];

export const reportContentBottom = [
    {
        id: "milage",
        title: "Пробег",
        text: "Проверяем данные по множеству источников, включая крупные автосервисы и базы объявлений."
    },
    {
        id: "usage",
        title: "История эксплуатации",
        text: "Узнайте реальную историю ухода за авто — проверим, вовремя ли делали ТО, какие серьёзные ремонты были и сколько вложили в содержание машины."
    },
    {
        id: "crash",
        title: "ДТП",
        text: "Проверим историю ДТП — покажем все зафиксированные аварии с этим автомобилем."
    }
];